/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 * Extracted ability-template data (was part of Abilities.ts). Pure data; consumed by Abilities.
*/

export const traits = [
		{
			label: "Legendary Resistance",
			name: "Legendary Resistance (3/day)",
			desc: "If the [MON] fails a saving throw, it can choose to succeed instead.",
			group: "Traits"
		},
		{
			label: "Spellcasting (INT)",
			name: "Spellcasting",
			attribute: 'Intelligence',
			desc: "The [MON] is a ???-level spellcaster. Its spellcasting ability is Intelligence (spell save DC [INT SAVE], [INT ATK] to hit with spell attacks). The [MON] has the following ??? spells prepared:\n\n> Cantrips (at will): *spell, spell, spell, spell*\n> 1st level (4 slots): *spell, spell, spell*\n> 2nd level (3 slots): *spell, spell, spell*\n> 3rd level (2 slots): *spell, spell*",
			group: "Traits"
		},
		{
			label: "Spellcasting (WIS)",
			name: "Spellcasting",
			attribute: 'Wisdom',
			desc: "The [MON] is a ???-level spellcaster. Its spellcasting ability is Wisdom (spell save DC [WIS SAVE], [WIS ATK] to hit with spell attacks). The [MON] has the following ??? spells prepared:\n\n> Cantrips (at will): *spell, spell, spell, spell*\n> 1st level (4 slots): *spell, spell, spell*\n> 2nd level (3 slots): *spell, spell, spell*\n> 3rd level (2 slots): *spell, spell*",
			group: "Traits"
		},
		{
			label: "Spellcasting (CHA)",
			name: "Spellcasting",
			attribute: 'Charisma',
			desc: "The [MON] is a ???-level spellcaster. Its spellcasting ability is Charisma (spell save DC [CHA SAVE], [CHA ATK] to hit with spell attacks). The [MON] has the following ??? spells prepared:\n\n> Cantrips (at will): *spell, spell, spell, spell*\n> 1st level (4 slots): *spell, spell, spell*\n> 2nd level (3 slots): *spell, spell, spell*\n> 3rd level (2 slots): *spell, spell*",
			group: "Traits"
		},
		{
			label: "Innate Spellcasting (INT)",
			name: "Innate Spellcasting",
			attribute: 'Intelligence',
			desc: "The [MON]'s innate spellcasting ability is Intelligence (spell save DC [INT SAVE], [INT ATK] to hit with spell attacks). It can innately cast the following spells, requiring no material components:\n\n> At will: *spell, spell, spell*\n> 3/day each: *spell, spell, spell*\n> 1/day each: *spell, spell*",
			group: "Traits"
		},
		{
			label: "Innate Spellcasting (WIS)",
			name: "Innate Spellcasting",
			attribute: 'Wisdom',
			desc: "The [MON]'s innate spellcasting ability is Wisdom (spell save DC [WIS SAVE], [WIS ATK] to hit with spell attacks). It can innately cast the following spells, requiring no material components:\n\n> At will: *spell, spell, spell*\n> 3/day each: *spell, spell, spell*\n> 1/day each: *spell, spell*",
			group: "Traits"
		},
		{
			label: "Innate Spellcasting (CHA)",
			name: "Innate Spellcasting",
			attribute: 'Charisma',
			desc: "The [MON]'s innate spellcasting ability is Charisma (spell save DC [CHA SAVE], [CHA ATK] to hit with spell attacks). It can innately cast the following spells, requiring no material components:\n\n> At will: *spell, spell, spell*\n> 3/day each: *spell, spell, spell*\n> 1/day each: *spell, spell*",
			group: "Traits"
		},
		{
			name: "Ambusher",
			desc: "The [MON] has advantage on attack rolls against any creature it has surprised.",
			group: "Traits"
		},
		{
			name: "Amorphous",
			desc: "The [MON] can move through a space as narrow as 1 inch wide without squeezing.",
			group: "Traits"
		},
		{
			name: "Amphibious",
			desc: "The [MON] can breathe air and water.",
			group: "Traits"
		},
		{
			name: "Angelic Weapons",
			desc: "The [MON]'s weapon attacks are magical. When the [MON] hits with any weapon, the weapon deals an extra [???d???] radiant damage (included in the attack).",
			group: "Traits"
		},
		{
			label: "Animal Telepathy",
			name: "??? Telepathy",
			desc: "The [MON] can magically command any ??? within 120 feet of it, using a limited telepathy.",
			group: "Traits"
		},
		{
			name: "Antimagic Susceptibility",
			desc: "The [MON] is incapacitated while in the area of an antimagic field. If targeted by dispel magic, the [MON] must succeed on a Constitution saving throw against the caster's spell save DC or fall unconscious for 1 minute.",
			group: "Traits"
		},
		{
			name: "Assassinate",
			desc: "During its first turn, the [MON] has advantage on attack rolls against any creature that hasn't taken a turn. Any hit the [MON] scores against a surprised creature is a critical hit.",
			group: "Traits"
		},
		{
			label: "Aversion to Damage",
			name: "Aversion to ???",
			desc: "If the [MON] takes ??? damage, it has disadvantage on attack rolls and ability checks until the end of its next turn.",
			group: "Traits"
		},
		{
			name: "Beast of Burden",
			desc: "The [MON] is considered to be a ??? animal for the purpose of determining its carrying capacity.",
			group: "Traits"
		},
		{
			name: "Berserk",
			desc: "Whenever the [MON] starts its turn with ??? hit points or fewer, roll a d6. On a 6, the [MON] goes berserk. On each of its turns while berserk, the [MON] attacks the nearest creature it can see. If no creature is near enough to move to and attack, the [MON] attacks an object, with preference for an object smaller than itself. Once the [MON] goes berserk, it continues to do so until it is destroyed or regains all its hit points.",
			group: "Traits"
		},
		{
			name: "Blind Senses",
			desc: "The [MON] can't use its blindsight while deafened and unable to smell.",
			group: "Traits"
		},
		{
			name: "Blood Frenzy",
			desc: "The [MON] has advantage on melee attack rolls against any creature that doesn't have all its hit points.",
			group: "Traits"
		},
		{
			name: "Brave",
			desc: "The [MON] has advantage on saving throws against being frightened.",
			group: "Traits"
		},
		{
			name: "Brute",
			desc: "A melee weapon deals one extra die of its damage when the [MON] hits with it (included in the attack).",
			group: "Traits"
		},
		{
			label: "Camouflage",
			name: "??? Camouflage",
			desc: "The [MON] has advantage on Dexterity (Stealth) checks made to hide in ??? terrain.",
			group: "Traits"
		},
		{
			name: "Charge",
			desc: "If the [MON] moves at least ??? ft. straight toward a target and then hits it with a ??? attack on the same turn, the target takes an extra [???d???] ??? damage. If the target is a creature, it must succeed on a DC ??? Strength saving throw or be knocked prone.",
			group: "Traits"
		},
		{
			name: "Chaotic Evil",
			desc: "the [MON] radiates a chaotic and evil aura.",
			group: "Traits"
		},
		{
			label: "Confer Resistance",
			name: "Confer ??? Resistance",
			desc: "The [MON] can grant resistance to ??? damage to anyone riding it.",
			group: "Traits"
		},
		{
			name: "Corrode Metal",
			desc: "Any nonmagical weapon made of metal that hits the [MON] corrodes. After dealing damage, the weapon takes a permanent and cumulative -1 penalty to damage rolls. If its penalty drops to -5, the weapon is destroyed. Non magical ammunition made of metal that hits the [MON] is destroyed after dealing damage.\nThe [MON] can eat through 2-inch-thick, nonmagical metal in 1 round.",
			group: "Traits"
		},
		{
			label: "Damage Absorption",
			name: "??? Absorption",
			desc: "Whenever the [MON] is subjected to ??? damage, it takes no damage and instead regains a number of hit points equal to the ??? damage dealt.",
			group: "Traits"
		},
		{
			name: "Damage Transfer",
			desc: "While it is grappling a creature, the [MON] takes only half the damage dealt to it, and the creature grappled by the [MON] takes the other half.",
			group: "Traits"
		},
		{
			name: "Dark Devotion",
			desc: "The [MON] has advantage on saving throws against being charmed or frightened.",
			group: "Traits"
		},
		{
			name: "Death Burst",
			desc: "When the [MON] dies, it explodes in a burst of ???. Each creature within ??? ft. of it must make a DC ??? Dexterity saving throw, taking [???d???] ??? damage on a failed save, or half as much damage on a successful one.",
			group: "Traits"
		},
		{
			name: "Devil's Sight",
			desc: "Magical darkness doesn't impede the [MON]'s darkvision.",
			group: "Traits"
		},
		{
			name: "Divine Awareness",
			desc: "The [MON] knows if it hears a lie.",
			group: "Traits"
		},
		{
			name: "Duergar Resilience",
			desc: "The [MON] has advantage on saving throws against poison, spells, and illusions, as well as to resist being charmed or paralyzed.",
			group: "Traits"
		},
		{
			name: "Dwarven Resilience",
			desc: "The [MON] has advantage on saving throws against poison, spells, and illusions, as well as to resist being charmed or paralyzed.",
			group: "Traits"
		},
		{
			name: "Earth Glide",
			desc: "The [MON] can burrow through nonmagical, unworked earth and stone. While doing so, the [MON] doesn't disturb the material it moves through.",
			group: "Traits"
		},
		{
			name: "Echolocation",
			desc: "The [MON] can't use its blindsight while deafened.",
			group: "Traits"
		},
		{
			name: "Elemental Demise",
			desc: "If the [MON] dies, its body disintegrates into ???, leaving behind only equipment the [MON] was wearing or carrying.",
			group: "Traits"
		},
		{
			label: "Elemental Form",
			name: "??? Form",
			desc: "The [MON] can enter a hostile creature's space and stop there. It can move through a space as narrow as 1 inch wide without squeezing.",
			group: "Traits"
		},
		{
			name: "Ephemeral",
			desc: "The [MON] can't wear or carry anything.",
			group: "Traits"
		},
		{
			name: "Ethereal Sight",
			desc: "The [MON] can see 60 ft. into the Ethereal Plane when it is on the Material Plane, and vice versa.",
			group: "Traits"
		},
		{
			name: "Evasion",
			desc: "If the [MON] is subjected to an effect that allows it to make a Dexterity saving throw to take only half damage, the [MON] instead takes no damage if it succeeds on the saving throw, and only half damage if it fails.",
			group: "Traits"
		},
		{
			name: "Evil",
			desc: "the [MON] radiates an evil aura.",
			group: "Traits"
		},
		{
			name: "False Appearance",
			desc: "While the [MON] remains motionless, it is indistinguishable from ???.",
			group: "Traits"
		},
		{
			name: "Fear Aura",
			desc: "Any creature hostile to the [MON] that starts its turn within ??? feet of the [MON] must make a DC ??? Wisdom saving throw, unless the [MON] is incapacitated. On a failed save, the creature is frightened until the start of its next turn. If a creature's saving throw is successful, the creature is immune to the [MON]'s Fear Aura for the next 24 hours.",
			group: "Traits"
		},
		{
			name: "Fey Ancestry",
			desc: "The [MON] has advantage on saving throws against being charmed, and magic can't put the [MON] to sleep.",
			group: "Traits"
		},
		{
			name: "Flyby",
			desc: "The [MON] doesn't provoke opportunity attacks when it flies out of an enemy's reach.",
			group: "Traits"
		},
		{
			name: "Freedom of Movement",
			desc: "The [MON] ignores difficult terrain, and magical effects can't reduce its speed or cause it to be restrained. It can spend 5 feet of movement to escape from nonmagical restraints or being grappled.",
			group: "Traits"
		},
		{
			name: "Gnome Cunning",
			desc: "The [MON] has advantage on Intelligence, Wisdom, and Charisma saving throws against magic.",
			group: "Traits"
		},
		{
			name: "Grappler",
			desc: "The [MON] has advantage on attack rolls against any creature grappled by it.",
			group: "Traits"
		},
		{
			name: "Halfling Nimbleness",
			desc: "The [MON] can move through the space of any creature that is of a size larger than its own.",
			group: "Traits"
		},
		{
			name: "Heated Body",
			desc: "A creature that touches the [MON] or hits it with a melee attack while within ??? feet of it takes [???d???] fire damage.",
			group: "Traits"
		},
		{
			name: "Heated Weapons",
			desc: "Any metal melee weapon the [MON] wields deals an extra [???d???] fire damage on a hit (included in the attack).",
			group: "Traits"
		},
		{
			name: "Hellish Weapons",
			desc: "The [MON]'s weapon attacks are magical and deal an extra [???d???] poison damage on a hit (included in the attacks).",
			group: "Traits"
		},
		{
			name: "Hold Breath",
			desc: "The [MON] can hold its breath for ???.",
			group: "Traits"
		},
		{
			name: "Ice Walk",
			desc: "The [MON] can move across and climb icy surfaces without needing to make an ability check. Additionally, difficult terrain composed of ice or snow doesn't cost it extra movement.",
			group: "Traits"
		},
		{
			name: "Illumination",
			desc: "The [MON] sheds bright light in a ???-foot radius and dim light in an additional ??? ft.",
			group: "Traits"
		},
		{
			name: "Immutable Form",
			desc: "The [MON] is immune to any spell or effect that would alter its form.",
			group: "Traits"
		},
		{
			name: "Incorporeal",
			desc: "The [MON] can move through other creatures and objects as if they were difficult terrain. It takes [???d???] force damage if it ends its turn inside an object.",
			group: "Traits"
		},
		{
			name: "Inscrutable",
			desc: "The [MON] is immune to any effect that would sense its emotions or read its thoughts, as well as any divination spell that it refuses. Wisdom (Insight) checks made to ascertain the [MON]'s intentions or sincerity have disadvantage.",
			group: "Traits"
		},
		{
			label: "Invisibility (Permanent)",
			name: "Invisibility",
			desc: "The [MON] is invisible.",
			group: "Traits"
		},
		{
			name: "Keen Hearing",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on hearing.",
			group: "Traits"
		},
		{
			name: "Keen Sight",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on sight.",
			group: "Traits"
		},
		{
			name: "Keen Smell",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on smell.",
			group: "Traits"
		},
		{
			name: "Keen Hearing and Sight",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on hearing or sight.",
			group: "Traits"
		},
		{
			name: "Keen Hearing and Smell",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on hearing or smell.",
			group: "Traits"
		},
		{
			name: "Keen Sight and Smell",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on sight or smell.",
			group: "Traits"
		},
		{
			name: "Keen Senses",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on sight, smell or hearing.",
			group: "Traits"
		},
		{
			name: "Lawful Evil",
			desc: "the [MON] radiates a lawful and evil aura.",
			group: "Traits"
		},
		{
			name: "Labyrinthine Recall",
			desc: "The [MON] can perfectly recall any path it has traveled.",
			group: "Traits"
		},
		{
			name: "Light Sensitivity",
			desc: "While in bright light, the [MON] has disadvantage on attack rolls, as well as on wisdom (perception) checks that rely on sight.",
			group: "Traits"
		},
		{
			name: "Limited Amphibiousness",
			desc: "The [MON] can breathe air and water, but it needs to be submerged at least once every 4 hours to avoid suffocating.",
			group: "Traits"
		},
		{
			name: "Limited Magic Immunity",
			desc: "The [MON] can't be affected or detected by spells of ??? level or lower unless it wishes to be. It has advantage on saving throws against all other spells and magical effects.",
			group: "Traits"
		},
		{
			name: "Limited Telepathy",
			desc: "The [MON] can magically communicate simple ideas, emotions, and images telepathically with any creature within ??? ft. of it.",
			group: "Traits"
		},
		{
			name: "Lucky",
			desc: "When the [MON] rolls a 1 on the d20 for an attack roll, ability check, or saving throw, it can reroll the die and must use the new roll.",
			group: "Traits"
		},
		{
			name: "Magic Resistance",
			desc: "The [MON] has advantage on saving throws against spells and other magical effects.",
			group: "Traits"
		},
		{
			name: "Magic Weapons",
			desc: "The [MON]'s weapon attacks are magical.",
			group: "Traits"
		},
		{
			name: "Martial Advantage",
			desc: "Once per turn, the [MON] can deal an extra [???d???] damage to a creature it hits with a weapon attack if that creature is within 5 ft. of an ally of the [MON] that isn't incapacitated.",
			group: "Traits"
		},
		{
			name: "Mimicry",
			desc: "The [MON] can mimic ??? sounds it has heard. A creature that hears the sounds can tell they are imitations with a successful DC ??? Wisdom (Insight) check.",
			group: "Traits"
		},
		{
			name: "Naturally Stealthy",
			desc: "The [MON] can attempt to hide even when it is obscured only by a creature that is at least one size larger than itself.",
			group: "Traits"
		},
		{
			name: "Pack Tactics",
			desc: "The [MON] has advantage on an attack roll against a creature if at least one of the [MON]'s allies is within 5 ft. of the creature and the ally isn't incapacitated.",
			group: "Traits"
		},
		{
			name: "Petrifying Gaze",
			desc: "If a creature starts its turn within ??? ft. of the [MON] and the two of them can see each other, the [MON] can force the creature to make a DC ??? Constitution saving throw if the [MON] isn't incapacitated. On a failed save, the creature magically begins to turn to stone and is restrained. It must repeat the saving throw at the end of its next turn. On a success, the effect ends. On a failure, the creature is petrified until freed by the greater restoration spell or other magic.\nA creature that isn't surprised can avert its eyes to avoid the saving throw at the start of its turn. If it does so, it can't see the [MON] until the start of its next turn, when it can avert its eyes again. If it looks at the [MON] in the meantime, it must immediately make the save.\nIf the [MON] sees its reflection within ??? ft. of it in bright light, it is affected by its own gaze.",
			group: "Traits"
		},
		{
			name: "Pounce",
			desc: "If the [MON] moves at least ??? ft. straight toward a target and then hits it with a ??? attack on the same turn, the target takes an extra [???d???] ??? damage. If the target is a creature, it must succeed on a DC ??? Strength saving throw or be knocked prone. If the target is prone, the [MON] can make another ??? attack against it as a bonus action.",
			group: "Traits"
		},
		{
			name: "Reactive",
			desc: "The [MON] can take one reaction on every turn in combat.",
			group: "Traits"
		},
		{
			name: "Reckless",
			desc: "At the start of its turn, the [MON] can gain advantage on all melee weapon attack rolls it makes during that turn, but attack rolls against it have advantage until the start of its next turn.",
			group: "Traits"
		},
		{
			name: "Regeneration",
			desc: "The [MON] regains ??? hit points at the start of its turn if it has at least 1 hit point.",
			group: "Traits"
		},
		{
			label: "Regeneration (Troll)",
			name: "Regeneration",
			desc: "The [MON] regains ??? hit points at the start of its turn. If the [MON] takes acid or fire damage, this trait doesn't function at the start of the [MON]'s next turn. The [MON] dies only if it starts its turn with 0 hit points and doesn't regenerate.",
			group: "Traits"
		},
		{
			label: "Relentless",
			name: "Relentless (Recharges after a Short or Long Rest)",
			desc: "If the [MON] takes ??? damage or less that would reduce it to 0 hit points, it is reduced to 1 hit point instead.",
			group: "Traits"
		},
		{
			name: "Rust Metal",
			desc: "Any nonmagical weapon made of metal that hits the [MON] corrodes. After dealing damage, the weapon takes a permanent and cumulative -1 penalty to damage rolls. If its penalty drops to -5, the weapon is destroyed. Non magical ammunition made of metal that hits the [MON] is destroyed after dealing damage.",
			group: "Traits"
		},
		{
			name: "Savage Attacks",
			desc: "When the [MON] scores a critical hit with a melee weapon attack, it can roll one of the weapon’s damage dice one additional time and add it to the extra damage of the critical hit.",
			group: "Traits"
		},
		{
			name: "Sea Legs",
			desc: "The [MON] has advantage on ability checks and saving throws to resist being knocked prone.",
			group: "Traits"
		},
		{
			name: "Sense Magic",
			desc: "The [MON] senses magic within 120 feet of it at will. This trait otherwise works like the detect magic spell but isn't itself magical.",
			group: "Traits"
		},
		{
			name: "Shielded Mind",
			desc: "The [MON] is immune to scrying and to any effect that would sense its emotions, read its thoughts, or detect its location.",
			group: "Traits"
		},
		{
			name: "Siege Monster",
			desc: "The [MON] deals double damage to objects and structures.",
			group: "Traits"
		},
		{
			name: "Slippery",
			desc: "The [MON] has advantage on ability checks and saving throws made to escape a grapple.",
			group: "Traits"
		},
		{
			label: "Sneak Attack",
			name: "Sneak Attack (1/Turn)",
			desc: "The [MON] deals an extra [???d???] damage when it hits a target with a weapon attack and has advantage on the attack roll, or when the target is within 5 ft. of an ally of the [MON] that isn't incapacitated and the [MON] doesn't have disadvantage on the attack roll.",
			group: "Traits"
		},
		{
			name: "Speak With Plants and Beasts",
			desc: "The [MON] can communicate with beasts and plants as if they shared a language.",
			group: "Traits"
		},
		{
			name: "Spider Climb",
			desc: "The [MON] can climb difficult surfaces, including upside down on ceilings, without needing to make an ability check.",
			group: "Traits"
		},
		{
			name: "Standing Leap",
			desc: "The [MON]'s long jump is up to ??? ft. and its high jump is up to ??? ft., with or without a running start.",
			group: "Traits"
		},
		{
			name: "Steadfast",
			desc: "The [MON] can't be frightened while it can see an allied creature within 30 feet of it.",
			group: "Traits"
		},
		{
			name: "Sunlight Sensitivity",
			desc: "While in sunlight, the [MON] has disadvantage on attack rolls, as well as on Wisdom (Perception) checks that rely on sight.",
			group: "Traits"
		},
		{
			name: "Sunlight Weakness",
			desc: "While in sunlight, the [MON] has disadvantage on attack rolls, ability checks, and saving throws.",
			group: "Traits"
		},
		{
			name: "Sure-Footed",
			desc: "The [MON] has advantage on Strength and Dexterity saving throws made against effects that would knock it prone.",
			group: "Traits"
		},
		{
			name: "Surprise Attack",
			desc: "If the [MON] surprises a creature and hits it with an attack during the first round of combat, the target takes an extra [???d???] damage from the attack.",
			group: "Traits"
		},
		{
			name: "Swarm",
			desc: "The swarm can occupy another creature's space and vice versa, and the swarm can move through any opening large enough for a ???. The swarm can't regain hit points or gain temporary hit points.",
			group: "Traits"
		},
		{
			name: "Trampling Charge",
			desc: "If the [MON] moves at least ??? ft. straight toward a target and then hits it with a ??? attack on the same turn, the target takes an extra [???d???] ??? damage. If the target is a creature, it must succeed on a DC ??? Strength saving throw or be knocked prone. If the target is prone, the [MON] can make another ??? attack against it as a bonus action.",
			group: "Traits"
		},
		{
			name: "Tunneler",
			desc: "The [MON] can burrow through solid rock at half its burrow speed and leaves a ???-foot-diameter tunnel in its wake.",
			group: "Traits"
		},
		{
			name: "Turn Resistance",
			desc: "The [MON] has advantage on saving throws against any effect that turns undead.",
			group: "Traits"
		},
		{
			name: "Two-Headed",
			desc: "The [MON] has advantage on Wisdom (Perception) checks and on saving throws against being blinded, charmed, deafened, frightened, stunned, and knocked unconscious.",
			group: "Traits"
		},
		{
			name: "Undead Fortitude",
			desc: "If damage reduces the [MON] to 0 hit points, it must make a Constitution saving throw with a DC of 5 + the damage taken, unless the damage is radiant or from a critical hit. On a success, the [MON] drops to 1 hit point instead.",
			group: "Traits"
		},
		{
			name: "Water Breathing",
			desc: "The [MON] can breathe only underwater.",
			group: "Traits"
		},
		{
			name: "Web Sense",
			desc: "While in contact with a web, the [MON] knows the exact location of any other creature in contact with the same web.",
			group: "Traits"
		},
		{
			name: "Web Walker",
			desc: "The [MON] ignores movement restrictions caused by webbing.",
			group: "Traits"
		},
	];
